import React, { ReactNode, useState } from 'react';

interface IBaseCollapse {
  title: string;
  isOpen: boolean;
  children: ReactNode;
}

interface IBaseItem {
  title: string;
  content: ReactNode;
}

interface IBaseCollapseItem {
  items: IBaseItem[];
  isOpen?: boolean;
  className?: string;
}

const CollapseItem: React.FC<IBaseCollapse> = (props: IBaseCollapse) => {
  const [isOpen, setIsOpen] = useState(props?.isOpen || false);

  const { title, children } = props;

  return (
    <div className="border border-gray-200 rounded-lg">
      <button
        className="w-full px-4 py-2 text-left focus:outline-none"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="flex justify-between items-center">
          <span className="text-gray-900">{title}</span>

          {/* TODO: pake icon yang bluebird */}
          <svg
            className={`w-6 h-6 transform transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </button>
      {isOpen && (
        <div className="px-4 pb-4">
          {children}
        </div>
      )}
    </div>
  );
};

const Collapse: React.FC<IBaseCollapseItem> = (props: IBaseCollapseItem) => {
  const { items } = props;
  return (
    <div className={`${props?.className} w-full mx-auto mb-4 bg-white`}>
      {items.map((item, index) => (
        <CollapseItem isOpen={props.isOpen || false} key={index} title={item.title}>
          {item.content}
        </CollapseItem>
      ))}
    </div>
  );
};

export default Collapse;
